import {Box, Center, Integer, Text} from 'platform/foundation';

import {Nullish, RequiredTestIdProps, suffixTestId} from 'shared/web';

import {BRANCH_BADGE_SIZE, BRANCH_BADGE_TEXT_COLOR} from '../../../constants/BRANCH_BADGE';
import {getSalesLeagueInitialsTextSize} from '../../../utils/getSalesLeagueInitialsTextSize';
import {getBranchBadgeColor} from '../utils/getBranchBadgeColor';
import {getBranchBadgeLabel} from '../utils/getBranchBadgeLabel';

interface SalesLeagueBranchBadgeProps extends RequiredTestIdProps {
  branchId: string;
  branchCode: string | Nullish;
  branchName: string;
  /** Defaults to the table row's tile; the podium passes one matching its text block. */
  size?: Integer;
}

export function SalesLeagueBranchBadge(props: SalesLeagueBranchBadgeProps) {
  const size = props.size ?? BRANCH_BADGE_SIZE;

  return (
    <Box
      width={size}
      height={size}
      backgroundColor={getBranchBadgeColor(props.branchId)}
      borderRadius="circular"
      flexShrink={0}
      data-testid={suffixTestId('branchBadge', props)}
    >
      <Center width="100%" height="100%">
        <Text
          size={getSalesLeagueInitialsTextSize(size)}
          color={BRANCH_BADGE_TEXT_COLOR}
          alternative
          noWrap
        >
          {getBranchBadgeLabel(props.branchCode, props.branchName)}
        </Text>
      </Center>
    </Box>
  );
}
